// removed by extract-text-webpack-plugin
module.exports = {"Dashed":"_1duFh","Normal":"_Q9VaV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Divider/Divider.scss
// module id = 563
// module chunks = 0